module.exports = __webpack_public_path__ + "media/images/visa-1b0c157cf5bebbadcf6f093370e709de.png";